import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class SsoUsersRoles extends Api {
  constructor(value = 'user_roles') {
    super(`sso/${value}/`);
  }

  removeAttachmentsNotificationModel = (id, imageId) => {
    return this.buildQuery(
      'delete',
      {
        data: {
          image_id: imageId,
        },
      },
      `${id}/remove_attachments`,
    );
  };

  updateNotificationModelFile(id, data) {
    return this.buildQuery(
      'put',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      `/${id}`,
    );
  }
}

export default SsoUsersRoles;
